var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "brochures-item" }, [
    _c("div", { staticClass: "brochures-item__div-wrap" }, [
      _c("div", { staticClass: "brochures-item__inner" }, [
        _c(
          "div",
          { staticClass: "brochures-item__image-wrap" },
          [
            _vm.brochureItem.ImageHtml.Src || _vm.brochureItem.ImageHtml.HasCrop
              ? _c("ResponsiveImage", {
                  attrs: {
                    imageModel: _vm.brochureItem.ImageHtml,
                    wrapClass: "brochures-item__image"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "brochures-item__text" }, [
          _c("h3", { staticClass: "brochures-item__headline" }, [
            _vm._v(_vm._s(_vm.brochureItem.Headline))
          ]),
          _vm._v(" "),
          _vm.brochureItem.HasBrochureFiles
            ? _c(
                "div",
                { staticClass: "brochures-item__form custom-select__form" },
                [
                  _c("div", { staticClass: "brochures-item__form-col" }, [
                    _c("div", { staticClass: "custom-select" }, [
                      _c("span", { staticClass: "custom-select__current" }, [
                        _c("span", {
                          staticClass: "custom-select__icon",
                          style: {
                            "background-image":
                              "url(" +
                              _vm.brochureItem.ActiveBrochureIconUrl +
                              ")"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "custom-select__label" }, [
                          _vm._v(_vm._s(_vm.brochureItem.ActiveBrochureLabel))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "custom-select__list" },
                        _vm._l(_vm.brochureItem.BrochureFiles, function(
                          file,
                          index
                        ) {
                          return file.HasFile && file.HasLanguage
                            ? _c(
                                "li",
                                {
                                  staticClass: "custom-select__list-item",
                                  attrs: {
                                    "data-url": file.FileUrl,
                                    "data-label": file.LanguageLabel,
                                    "data-icon": file.LanguageIconUrl
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "custom-select__icon",
                                    style: {
                                      "background-image":
                                        "url(" + file.LanguageIconUrl + ")"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "custom-select__label" },
                                    [_vm._v(_vm._s(file.LanguageLabel))]
                                  )
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "brochures-item__form-col" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "brochures-item__form-button custom-select__button",
                        attrs: {
                          href: _vm.brochureItem.ActiveBrochureUrl,
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.dictionaries.BrochureDownloadLabel))]
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bbe389d", { render: render, staticRenderFns: staticRenderFns })
  }
}